<template>
  <div>
    <el-container class="pb-10" style="height: 40em">
      <el-main>
        <el-row>
          <el-col class="pt-2">
            <el-row>
              <el-col :xs="12" :md="12" class="p-4">
                <el-col :xs="24">Ano:</el-col>
                <el-select @change="payload => ano = payload"
                           v-model="ano" filterable
                           placeholder="Ano"  :span="12">
                  <el-option
                    v-for="item in anos"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :xs="12" :md="12" class="p-4">
                <el-col :xs="24">Mês:</el-col>
                <el-select :span="12"
                           v-model="mes"
                           placeholder="Mês" >
                  <el-option
                    v-for="item in meses"
                    :key="item.mes"
                    :label="item.nome"
                    :value="item.mes" >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row class="pl-4 pt-2 book-filter-aside">
          <el-col :xs="24" :md="20" class="pr-2">
            <el-input
              placeholder="Centro De Custo ..."
              v-model="filterText" class="pb-4">
            </el-input>
            <el-tree
              @current-change.sync="payload => centroCusto = payload"
              class="filter-tree"
              :data="arvoreCentroCustos"
              :props="defaultProps"
              :highlight-current="true"
              default-expand-all
              node-key="id"
              :default-checked-keys="defaultCheckedKeys"
              :filter-node-method="filterNode"
              ref="tree2">
            </el-tree>
          </el-col>
          <el-col :xs="24" :md="4">
            <el-button type="danger" class="pull-right" @click="saveInState" size="small">Salvar</el-button>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>

</template>
<style>
  .book-filter-aside .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #3F729B !important;
    color: #fff !important;
    font-weight: bold;
  }
</style>

<script>
  import {mapState, mapActions, mapGetters} from 'vuex'
  import {Notification} from 'element-ui'

  export default {
    name: 'aside-filter',
    watch: {
      filterText(val) {
        this.$refs.tree2.filter(val);
      }
    },
    computed: {
      defaultCheckedKeys() {
        const checked = this.centroCustoSelected
        let keys = []
        if (!_.isObjectLike(checked)) {
          return keys
        }
        keys.push(checked.id)
        return keys
      },
      arvoreCentroCustos() {
        if (!this.user || !this.user.hasOwnProperty('centroCustoArvore')) {
          return []
        }
        return this.user.centroCustoArvore
      },
      ...mapGetters(['competenciasNormais']),
      ...mapState(['anos', 'meses','anoSelected' , 'mesSelected' , 'user', 'centroCustoSelected' ])
    },
    methods: {
      ...mapActions(['setCentroCustoSelected', 'setAnoSelected', 'setMesSelected', 'setFilterUpdateAt']),
      filterNode(value, data) {
        if (!value) return true;
        return data.nome.toUpperCase().indexOf(value.toUpperCase()) !== -1;
      },
      saveInState() {
        this.setCentroCustoSelected(this.centroCusto)
        this.setAnoSelected(this.ano)
        this.setMesSelected(this.mes)
        this.setFilterUpdateAt(new Date().getTime())
        document.body.classList.toggle('aside-menu-hidden')
        Notification.success("Filtro salvo")
      }
    },
    data() {
      return {
        filterText: '',
        centroCusto: null,
        ano: null,
        mes: null,
        defaultProps: {
          children: 'childrens',
          label: 'nome'
        }
      };
    },
    mounted() {
      this.ano = this.anoSelected
      this.mes= this.mesSelected
      this.centroCusto = this.centroCustoSelected
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AsideFilter.vue